import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ICampaign, ICreatePhaseRequest } from '../../../models/campaign/campaign.interface';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CampaignService } from '../../../services/campaign.service';
import { AccountInfo } from '@azure/msal-browser';
import { AccountInfoService } from '../../../services/account-info.service';
import { ObservableInput, Subject, takeUntil } from 'rxjs';
import { ToastBarService } from '../../../services/toast-bar.service';

@Component({
    selector: 'app-create-campaign',
    imports: [
        RouterLink,
        ReactiveFormsModule,
        FormsModule,
        NgIf
    ],
    templateUrl: './create-campaign.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './create-campaign.component.scss'
})
export class CreateCampaignComponent implements OnInit {
  campaign!: ICampaign;
  campaignName: string = "";
  campaignCreated: boolean = false;
  user?: AccountInfo;
  private _destroy$ = new Subject<void>();
  isCreateDisabled: boolean = false;

  constructor(
    private router: Router,
    private location: Location,
    private campaignService: CampaignService,
    private accountInfoService: AccountInfoService,
    private toastBarService: ToastBarService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.campaignName = nav?.extras?.state?.['campaignName'] ?? '';
  }

  ngOnInit(): void {
    this.accountInfoService.accountInfo$
      .pipe(takeUntil(this._destroy$))
      .subscribe((data) => {
        this.user = data;
      });
  }

  goBack() {
    this.location.back();
  }

  createCampaign() {
    console.log("Create Campaign: ", this.campaignName);

    const initialPhase: ICreatePhaseRequest = {
      phaseName: "Phase 1",
      phaseOrder: 1,
      userInfo: {
        name: this.user?.name,
        username: this.user?.username,
      }
    };

    let campaignData: any = {
      campaignName: this.campaignName,
      userInfo: {
        name: this.user?.name,
        username: this.user?.username,
      },
      initialPhases: [initialPhase]
    };

    this.campaignService.createCampaign(campaignData).subscribe({
      next: (res: any) => {
        this.isCreateDisabled = true;
        this.toastBarService.showToastSuccess("Campaign created successfully!");
        this.campaign = res;

        // Redirect to campaign edit page
        setTimeout(() => {
          this.router.navigate(['/campaign/edit'], {
            state: {
              campaignData: {
                campaignName: res.campaignName,
                campaignId: res.campaignId
              }
            }
          });
        }, 1000);
      },
      error: (err: any) => {
        this.toastBarService.showToastError("Campaign creation failed!");
        console.error('Error create campaign', err);
      }
    });

    this.campaignCreated = true;
  }
}
